<template>
   <div
      id="app-wrapper"
      :class="{ 'show-meta': showMeta, 'legacy-container': legacyContainer }">
      <pin
         top="10"
         left="10"
         fixed
         class="breakpoint-indicator"
         :title="width"
         :class="{ 'd-none': !indicator }"
         @click.ctrl="Object.keys(componentVariants).forEach((type) => cycleVariant(type))">
         <div>{{ breakpoint }}</div>
         <div>{{ width }}</div>
      </pin>
      <findforsikring-header-old />
      <div id="form-wrap-old">
         <main style="background-color: #fff">
            <component
               :is="formComponent"
               v-bind="mainComponentProps" />
            <div v-if="!formOnly">
               <grey-banner-section-old />
               <material-savings-video-old />
               <material-testimonials-old />
               <material-savings-old />
               <material-used-by-old />
               <material-partners />
               <material-reasons />
               <material-customer-support-old />
               <material-topics style="background-color: #fff" />
            </div>
         </main>
         <material-footer :mini="formOnly" />
      </div>
      <call-me-modal />
      <landingpage-tour />
   </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import LandingpageTour from '@components/LandingpageTour';
import MaterialPartners from '@components/MaterialPartners';
import MaterialReasons from '@components/MaterialReasons';
import CallMeModal from '@components/CallMeModal';
import FindforsikringJumbo from '@components/FindforsikringJumbo';
import FindforsikringJumboOld from '@components/FindforsikringJumboOld';
import FindforsikringHeaderOld from '@components/FindforsikringHeaderOld';
import GreyBannerSectionOld from '@components/GreyBannerSectionOld';
import MaterialSavingsVideoOld from '@components/MaterialSavingsVideoOld';
import MaterialTestimonialsOld from '@components/MaterialTestimonialsOld';
import MaterialSavingsOld from '@components/MaterialSavingsOld';
import MaterialUsedByOld from '@components/MaterialUsedByOld';
import MaterialCustomerSupportOld from '@components/MaterialCustomerSupportOld';
import MaterialTopics from '@components/MaterialTopics';
import MaterialFooter from '@components/MaterialFooter';
import Pin from '@components/Pin';
import SelectMoreForm from '@components/Form/SelectMoreForm';
import AltCarFormNew from '@components/AltCarFormNew';
import WistiaBlock from '@components/WistiaBlock';
import FindforsikringStatsJumbo from '@components/FindforsikringStatsJumbo';

const QueryString = require('query-string');

export default {
   name: 'LandingPage',
   components: {
      FindforsikringStatsJumbo,
      WistiaBlock,
      AltCarFormNew,
      SelectMoreForm,
      Pin,
      LandingpageTour,
      CallMeModal,
      MaterialFooter,
      MaterialTopics,
      MaterialCustomerSupportOld,
      MaterialReasons,
      MaterialPartners,
      MaterialUsedByOld,
      MaterialSavingsOld,
      MaterialTestimonialsOld,
      MaterialSavingsVideoOld,
      GreyBannerSectionOld,
      FindforsikringJumbo,
      FindforsikringHeaderOld,
   },
   data() {
      return {
         ready: false,
         query: {},
         showMeta: false,
         legacyContainer: true,
         currentComponentVersionIndex: {
            header: 0,
            jumbo: 0,
            section1: 0,
            section2: 0,
            section3: 0,
            section4: 0,
            section5: 0,
            section6: 0,
            section7: 0,
            footer: 0,
         },
         componentVariants: {
            header: ['findforsikring-header-old', 'findforsikring-header'],
            jumbo: ['findforsikring-jumbo-old', 'findforsikring-jumbo'],
            section1: ['grey-banner-section-old', 'blue-banner-section'],
            section2: ['material-savings-video-old', 'steps-section'],
            section3: ['material-testimonials-old', 'material-savings-video'],
            section4: ['material-savings-old', 'material-savings'],
            section5: ['material-used-by-old', 'trustpilot-easy-switch'],
            section6: ['material-customer-support-old', 'material-customer-support'],
            section7: ['material-topics', 'topics-section'],
            footer: ['material-footer', 'footer-section'],
         },
      };
   },
   computed: {
      header() {
         return this.$store.state.header;
      },
      formOnly() {
         return this.$store.state.form_only;
      },
      formComponent() {
         const page = this.landingpage;
         if (page && page.component) {
            return page.component;
         }
         return 'findforsikring-jumbo';
      },
      landingpage() {
         const path = document.location.pathname;
         const query = new URLSearchParams(document.location.search);
         if (query.has('variant')) {
            const variant = query.get('variant');
            for (const page of this.pages) {
               if (page.test.test(variant)) {
                  page.product = this.findProductByIcon(page.icon);
                  return page;
               }
            }
         }
         for (const page of this.pages) {
            if (page.test.test(path)) {
               page.product = this.findProductByIcon(page.icon);
               return page;
            }
         }
         return null;
      },
      componentVariant() {
         return (type) => this.componentVariants[type][this.currentComponentVersionIndex[type]];
      },
      jumboComponent() {
         if (this.$store.state.versions.jumbo === 1) {
            return FindforsikringJumboOld;
         }
         return FindforsikringJumbo;
      },
      mainComponentProps() {
         if (!this.landingpage || !this.landingpage.props) {
            return {};
         }
         return this.landingpage.props;
      },
      allLinks() {
         let base = 'https://www.findforsikring.dk/';
         if (process.env.NODE_ENV === 'development') {
            base = '/';
         }
         return this.pages.map((page) => {
            const test = String(page.test);
            const pattern = /\W*([\w-]+)/;
            const match = pattern.exec(test);
            return base + match[1];
         });
      },
      ...mapGetters([
         'lte',
         'gte',
         'stats',
         'breakpoint',
         'width',
         'height',
         'indicator',
         'pages',
         'allIdentifiers',
         'findProductByIcon',
      ]),
   },
   beforeMount() {
      this.currentComponentVersionIndex = {
         ...this.currentComponentVersionIndex,
         ...(window.optimizeVariables || {}),
      };
      console.log('component idx before mount', JSON.parse(JSON.stringify(this.currentComponentVersionIndex)));
      window.addEventListener('resize', this.onResize);
      window.addEventListener('keydown', this.onAltDown);
      window.addEventListener('keyup', this.onAltUp);
      this.onResize();
      const { landingpage } = this;
      if (landingpage) {
         this.$store.commit('setLandingpage', landingpage);
         const { product } = landingpage;
         if (product && product.count === 0) {
            this.addProduct(product);
         }

         if (landingpage.form_only) {
            this.setFormOnly(true);
         }
      }
      this.query = QueryString.parse(document.location.search);
   },
   mounted() {
      this.$nextTick(() => {
         this.ready = true;
      });
      this.$cookies.config('30d', '/');
      this.setupAffiliates();
      this.addProductsFromQuery();
      global.pageComponent = this;
   },
   beforeUnmount() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('keydown', this.onAltDown);
      window.removeEventListener('keyup', this.onAltUp);
   },
   methods: {
      ...mapMutations(['setFormOnly', 'updateWidth', 'addProduct', 'updateHeight']),
      openAll() {
         let delay = 100;
         this.allLinks.forEach((link) => {
            setTimeout(() => {
               window.open(link, '_blank');
            }, delay);
            delay += 100;
         });
      },
      openVariants(baseUrl) {
         let delay = 0;
         [
            '/',
            '/3-tilbud-paa-en-billig-forsikring',
            '/3-tilbud-paa-en-billig-bilforsikring',
            '/start',
            '/billig-bilforsikring-faa-3-gratis-tilbud-2',
            '/3-tips-til-den-bedste-forsikring',
         ].forEach((path) => {
            if (baseUrl) {
               console.log(`${baseUrl}?variant=${path}`);
            } else {
               setTimeout(() => {
                  if (document.location.pathname !== path) {
                     window.open(path, '_blank');
                  }
               }, (delay += 100));
            }
         });
      },
      setVariant(type, index) {
         console.log('changing variant', type);
         this.currentComponentVersionIndex[type] = index;
      },
      onResize() {
         this.updateWidth(window.innerWidth);
         this.updateHeight(window.innerHeight);
         document.body.height = window.innerHeight;
      },
      onAltDown(e) {
         if (e.key === 'Control') {
            this.showMeta = true;
         }
      },
      onAltUp(e) {
         if (e.key === 'Control') {
            this.showMeta = false;
         }
      },
      addProductsFromQuery() {
         this.allIdentifiers.forEach((identifier) => {
            if (this.query[identifier]) {
               const product = this.findProductByIcon(identifier);
               if (product.count === 0) {
                  this.addProduct(product);
               }
            }
         });
      },
      setupAffiliates() {
         const { query } = this;
         const source = (query.utm_source || '').trim().toLocaleLowerCase() || this.$cookies.get('affiliate_source');
         const campaign =
            (query.utm_campaign || '').trim().toLocaleLowerCase() || this.$cookies.get('affiliate_campaign');
         if (source) {
            this.$cookies.set('affiliate_source', source);
            if (source === 'eovendo') {
               const user = query.UserId.trim();
               this.$cookies.set('EovendoUserCookie', user);
            }
            if (source === 'partnerads') {
               const paid = query.paid || '' || this.$cookies.get('partnerads_paid');
               const pacid = query.pacid || '' || this.$cookies.get('partnerads_pacid');
               console.log({
                  paid,
                  pacid,
               });
               if (paid && pacid) {
                  this.$cookies.set('partnerads_paid', paid, '40d').set('partnerads_pacid', pacid, '40d');
               }
            }
         }
         if (campaign) {
            this.$cookies.set('affiliate_campaign', campaign);
         }
         // Heylink
         const hltid = (query.hltid || '').trim();
         const hlofid = (query.hlofid || '').trim();
         if (hltid) {
            this.$cookies.set('heylink_hltid', hltid, '40d');
            this.$cookies.set('heylink_hlofid', hlofid, '40d');
         }
      },
      startTour() {
         this.$tours['landingpage-tour'].start();
      },
      cycleVariant(type) {
         this.currentComponentVersionIndex[type] =
            (this.currentComponentVersionIndex[type] + 1) % this.componentVariants[type].length;
      },
   },
};
</script>

<style lang="scss" scoped>
.breakpoint-indicator {
   background-color: var(--ff-dark-blue);
   cursor: pointer;
   display: flex;
   flex-direction: column;
   font-size: 11px;
   line-height: 1.25;
   align-items: center;
   justify-content: center;
   color: #fff;
   border-radius: 50%;
   width: 30px;
   height: 30px;
}
#form-wrap-old {
}
</style>
